import { useIntl } from "react-intl";

const Sandbox = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.Sandbox.header",
            defaultMessage: "Sandbox"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.Sandbox.body",
            defaultMessage:
                "Test and control the rollout of updates and new apps in a sandbox copy of your environment before rolling it out companywide. Apply your existing change management practices, ensure compatibility with your ecosystem, and prepare end users if necessary."
        })
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default Sandbox;
